import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TableHttpHelpers, TableHttpService, TableSource } from '@klickdata/core/table';
import { PaginatorResponse, ResponseData } from '@klickdata/core/http';
import { User, UserData, UserService as Base } from '@klickdata/core/user';

@Injectable()
export class UsersService extends Base implements TableHttpService<User> {
    /**
     * Service for fetching customer users in a table.
     */
    public fetchData(source: TableSource<User>): Observable<ResponseData<User[]>> {
        const req = this.builder.get<UserData[]>(this.resourceUrl);
        if (source.filter?.filter?.filters?.findIndex((filter) => filter.property === 'customer') === -1) {
            req.param('customer', this.customer_id);
        }
        if (source.filter?.filter?.filters?.findIndex((filter) => filter.property.indexOf('reference') !== -1) !== -1) {
            req.param('referenceCount', 1);
        }
        TableHttpHelpers.managePagination(source.paginator, req);
        TableHttpHelpers.manageSort(source.sort, req);
        TableHttpHelpers.mapFilter(source.filter, req);

        return req.request().pipe(
            map((res: PaginatorResponse<UserData[]>) => {
                return {
                    data: this.mapUsers(res.data),
                    notify: res.notify,
                    paginator: res.paginator,
                    more: res.more,
                };
            })
        );
    }
}
